import { render } from "./GroupProductModal.vue?vue&type=template&id=0b8d4d0a"
import script from "./GroupProductModal.vue?vue&type=script&lang=js"
export * from "./GroupProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__